<div class="detail-page">
  @if (tuki) {
    <h2>{{ tuki.nimi }}</h2>
  } @else {
    <h2>Moniyritystukea ei löytynyt</h2>
  }

  @if (tuki?.avain && (kirjanpitajaOnDevaajaObservable | async)) {
    <div style="margin-bottom: 20px; padding: 10px; max-width: 1020px; position: relative" class="mat-elevation-z2">
      <span style="font-size: 10px; position: absolute; top: 3px; right: 5px" class="light-gray-text">(Vain devaajat)</span>
      <h3 style="margin: 0 0 1em">Urit</h3>
      <div style="padding-left: 1em; padding-right: 1em">
        <h4 style="margin: 0 0 0.5em">Lemonator</h4>
        @for (linkki of debugLinkitLemonator; track linkki.uri) {
          <div>
            {{ linkki.otsikko }}: <a [href]="linkki.encodedUri" target="_BLANK">{{ linkki.uri }}</a>
          </div>
        }
        <h4 style="margin: 1em 0 0.5em">Lemonaid</h4>
        @for (linkki of debugLinkitLemonaid; track linkki.uri) {
          <div>
            {{ linkki.otsikko }}: <a [href]="linkki.encodedUri" target="_BLANK">{{ linkki.uri }}</a>
          </div>
        }
      </div>
    </div>
  }

  <div style="max-width: 800px">
    <p style="margin-bottom: 20px">Tukeen liitetyt käyttäjät voivat vaihtaa Lemonaid-appissa yrityksestä toiseen ilman uutta kirjautumista. Tuki muodostuu ja päivittyy automaattisesti henkilötunnuksen perusteella, kun käyttäjä tunnistautuu vahvasti tai hetu poistetaan. Osallisia ei muokata käsin.</p>

    <h3>Osalliset</h3>
    @for (osallinen of osalliset; track osallinen.kayttajaAvain) {
      <div style="display: flex; align-items: center; gap: 14px; padding: 8px 0; border-bottom: 1px solid rgba(0, 0, 0, 0.08)">
        <div style="flex: 1">
          <a style="font-weight: 600" [href]="'/asiakkaat/' + osallinen.asiakasAvain + '/kayttajat/' + osallinen.kayttajaAvain" target="_blank" rel="noopener">{{ osallinen.etunimi }} {{ osallinen.sukunimi }}</a>
          <div style="font-size: 12px; color: gray">{{ osallinen.email }}</div>
        </div>
        <div style="flex: 1">
          <a [href]="'/asiakkaat/' + osallinen.asiakasAvain + '/asiakastiedot'" target="_blank" rel="noopener">{{ osallinen.asiakasNimi }}</a>
          <div style="font-size: 12px; color: gray">{{ osallinen.ytunnus }}</div>
        </div>
      </div>
    }

    <div style="display: flex; gap: 10px; margin-top: 30px; align-items: center">
      <app-secondary-button (click)="takaisin()" actionId="Takaisin moniyritystukien listaan">Takaisin</app-secondary-button>
    </div>
  </div>
</div>
